export const API_KEY_SCOPES = [
  'contacts:read',
  'contacts:write',
  'sends:read',
  'sends:write',
  'templates:read',
  'templates:write',
  'layouts:read',
  'layouts:write',
  'schedules:read',
  'schedules:write',
  'senders:read',
  'senders:write',
] as const
export type ApiKeyScope = (typeof API_KEY_SCOPES)[number]

export const API_KEY_RESOURCES = ['contacts', 'sends', 'templates', 'layouts', 'schedules', 'senders'] as const
export type ApiKeyResource = (typeof API_KEY_RESOURCES)[number]

export interface ApiKey {
  id: string
  name: string
  prefix: string
  scopes: ApiKeyScope[]
  isAdmin: boolean
  lastUsedAt: string | null
  active: boolean
  createdAt: string
  updatedAt: string
}

export interface ApiKeyCreated extends ApiKey {
  key: string
}

export interface CreateApiKeyPayload {
  name: string
  scopes: ApiKeyScope[]
  isAdmin?: boolean
}

export interface UpdateApiKeyPayload {
  name?: string
  active?: boolean
  scopes?: ApiKeyScope[]
  isAdmin?: boolean
}
